import { render } from "./A2202.vue?vue&type=template&id=35662178"
import script from "./A2202.vue?vue&type=script&lang=js"
export * from "./A2202.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ZYSRC\\FW\\fwm_web-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__